import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface SplashScreenProps {
    message?: string;
}

/**
 * Splash screen shown during initial app load
 * Provides visual feedback while the JavaScript bundle is downloading and parsing
 */
export const SplashScreen: React.FC<SplashScreenProps> = ({ message = 'Loading...' }) => {
    const theme = useTheme();

    const containerStyle: React.CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        width: '100vw',
        padding: '2rem',
        textAlign: 'center',
        backgroundColor: theme.colors.background,
        color: theme.colors.text.primary,
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999,
    };

    const spinnerStyle: React.CSSProperties = {
        width: '60px',
        height: '60px',
        marginBottom: '1.5rem',
    };

    const messageStyle: React.CSSProperties = {
        fontSize: theme.typography.fontSize.lg,
        color: theme.colors.text.secondary,
        marginTop: '1rem',
    };

    return (
        <div style={containerStyle}>
            <img
                src="/logo-spinner.gif"
                alt="Loading"
                style={spinnerStyle}
            />
            <div style={messageStyle}>
                {message}
            </div>
        </div>
    );
};

